import { Link, useLocation } from 'wouter';
import { Newspaper, FileText, User, Compass } from 'lucide-react';

const NAV_ITEMS = [
  { href: '/', label: '晨报', icon: Compass },
  { href: '/news', label: '要闻', icon: Newspaper },
  { href: '/scripts', label: '话术', icon: FileText },
  { href: '/profile', label: '我的', icon: User },
];

export function Shell({ children }: { children: React.ReactNode }) {
  const [location] = useLocation();

  return (
    <div className="flex h-[100dvh] w-full bg-background overflow-hidden text-foreground">
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex flex-col w-64 bg-sidebar text-sidebar-foreground flex-shrink-0">
        <div className="p-6">
          <div className="flex items-center gap-3 text-sidebar-primary font-bold text-xl">
            <div className="w-8 h-8 rounded bg-sidebar-primary flex items-center justify-center text-sidebar">
              <Compass size={20} strokeWidth={2.5} />
            </div>
            <span>财研助手</span>
          </div>
        </div>
        <nav className="flex-1 px-4 space-y-2 mt-4">
          {NAV_ITEMS.map((item) => {
            const isActive = location === item.href || (item.href !== '/' && location.startsWith(item.href));
            const Icon = item.icon;
            return (
              <Link 
                key={item.href} 
                href={item.href}
                className={`flex items-center gap-3 px-4 py-3 rounded-md transition-all ${
                  isActive 
                    ? 'bg-sidebar-accent text-sidebar-accent-foreground font-medium' 
                    : 'text-sidebar-foreground/80 hover:bg-sidebar-accent/50 hover:text-sidebar-foreground'
                }`}
                data-testid={`nav-desktop-${item.label}`}
              >
                <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                <span>{item.label}</span>
              </Link>
            )
          })}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col min-w-0 overflow-y-auto pb-16 md:pb-0 relative bg-background">
        {children}
      </main>

      {/* Mobile Bottom Tab Bar */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 h-[68px] bg-card border-t border-border flex items-center justify-around z-50 px-2 pb-safe bg-card/90 backdrop-blur-md">
        {NAV_ITEMS.map((item) => {
          const isActive = location === item.href || (item.href !== '/' && location.startsWith(item.href));
          const Icon = item.icon;
          return (
            <Link 
              key={item.href} 
              href={item.href}
              className={`flex flex-col items-center justify-center w-full h-full space-y-1.5 transition-colors ${
                isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
              }`}
              data-testid={`nav-mobile-${item.label}`}
            >
              <div className={`relative flex items-center justify-center w-12 h-8 rounded-full transition-colors ${isActive ? 'bg-primary/10' : 'bg-transparent'}`}>
                <Icon size={22} strokeWidth={isActive ? 2.5 : 2} className={isActive ? 'text-primary' : ''} />
              </div>
              <span className={`text-[11px] ${isActive ? 'font-medium' : 'font-normal'}`}>{item.label}</span>
            </Link>
          )
        })}
      </nav>
    </div>
  );
}
